import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DragulaModule } from 'ng2-dragula';
import { TranslateModule } from '@ngx-translate/core';
// Components
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { ContentComponent } from './components/layout/content/content.component';
import { FullComponent } from './components/layout/full/full.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';
// Header Elements Components
import { BookmarkComponent } from './components/header/elements/bookmark/bookmark.component';
import { MessageBoxComponent } from './components/header/elements/message-box/message-box.component';
import { MyAccountComponent } from './components/header/elements/my-account/my-account.component';

// Services
import { LayoutService } from './services/layout.service';
import { NavService } from './services/nav.service';
import { DecimalPipe } from '@angular/common';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SwiperModule } from 'swiper/angular';
import { SearchPipe } from './pipe/search.pipe';
import { LanguagesComponent } from './components/header/elements/languages/languages.component';
import { NotificationComponent } from './components/header/elements/notification/notification.component';
import { SwiperComponent } from './components/header/elements/swiper/swiper.component';
import { DateFormatPipe } from './pipe/date-format.pipe';
import { CardBtnComponent } from './components/card-btn/card-btn.component';
import { NgbdSortableHeaderDirective } from './directives/ngbd-sortable-header.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { DeleteItemComponent } from './components/delete-item/delete-item.component';
import { ImageResizeDirective } from './directives/image-resize.directive';
import { SanitizeHtmlPipe } from './pipe/sanitize-html.pipe';
import { DecimalDirective } from './directives/decimal.directive';
import { TimeLineComponent } from './components/time-line/time-line.component';
import { TimeAgoPipe } from './pipe/time-ago.pipe';
import { ConfirmItemComponent } from './components/confirm-item/confirm-item.component';
import { EmployeeCodeAccessComponent } from './components/empoyee-code-access/employee-code-access.component';
import { TruncatePipe } from './pipe/truncate.pipe';
import { StatsNumbersComponent } from './components/simulator-stats/stats-numbers/stats-numbers.component';
import { CapitalizePipe } from './pipe/capitalize.pipe';
import { ShortNumberPipe } from './pipe/short-number.pipe';
import { OverallBalanceComponent } from './components/charts/overall-balance/overall-balance.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SuccessMessageComponent } from './components/success-message/success-message.component';
import { ToggleScreenComponent } from './components/header/elements/toggle-screen/toggle-screen.component';
import { CardComponent } from './components/ui/card/card.component';
import { CardDropdownButtonComponent } from './components/ui/card/card-dropdown-button/card-dropdown-button.component';
import { LimitReachedPopupComponent } from './components/limit-reached-popup/limit-reached-popup.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TwoDecimalPipe } from './pipe/twoDecimal.pipe';
import { OrdersByCategoriesComponent } from './components/tables-charts/orders-by-categories/orders-by-categories.component';
import { TopSellingProductsComponent } from './components/tables-charts/top-selling-products/top-selling-products.component';
import { ShippingTimeLineComponent } from './components/shipping-time-line/shipping-time-line.component';
import { PickupRequestTimeLineComponent } from './components/pickup-request-time-line/pickup-request-time-line.component';
import { PickupRequestParcelsComponent } from './components/pickup-request-parcels-view/pickup-request-parcels.component';
import { PickupRequestParcelsDetailsComponent } from './components/pickup-request-parcels-view/pickup-request-parcels-details/pickup-request-parcels-details.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ProgressChartComponent } from './components/charts/progress-chart/progress-chart.component';
import { MonthTranslatePipe } from './pipe/monthTranslate.pipe';
import { InverseTableBackgroundComponent } from './components/tables-charts/inverse-table-background/inverse-table-background.component';
import { AppTitlePipe } from './pipe/app-title.pipe';
import { ApiSyncModalComponent } from './components/ui/modal/api-sync-modal/api-sync-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { QrScannerComponent } from './components/qr-scanner/qr-scanner.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BidiModule } from '@angular/cdk/bidi';
import { ScanModalComponent } from './components/qr-scanner/modals/scan-modal/scan-modal.component';
import { BarcodeComponent } from './components/Barcode/barcode.component';
import { ProjectSelectorComponent } from './components/header/elements/project-selector/project-selector.component';
import { HeaderSettingsComponent } from './components/header/elements/settings/header-settings.component';
import { LoadingTableComponent } from './components/loading-table/loading-table.component';
import { HeaderAdministrationComponent } from './components/header/elements/administration/header-administration.component';
import { NumberToWordsPipe } from './pipe/number-to-words.pipe';
import { MathCalculatorComponent } from './components/math-calculator/math-calculator.component';

@NgModule({
	declarations: [
		HeaderComponent,
		FooterComponent,
		SidebarComponent,
		ContentComponent,
		BreadcrumbComponent,
		FeatherIconsComponent,
		FullComponent,
		LoaderComponent,
		TapToTopComponent,
		BookmarkComponent,
		MessageBoxComponent,
		LanguagesComponent,
		NotificationComponent,
		MyAccountComponent,
		ProjectSelectorComponent,
		SvgIconComponent,
		SwiperComponent,
		CardBtnComponent,
		CardBtnComponent,
		DeleteItemComponent,
		SuccessMessageComponent,
		EmployeeCodeAccessComponent,
		ConfirmItemComponent,
		TimeLineComponent,
		StatsNumbersComponent,
		LimitReachedPopupComponent,
		OverallBalanceComponent,
		ToggleScreenComponent,
		CardComponent,
		CardDropdownButtonComponent,
		OrdersByCategoriesComponent,
		TopSellingProductsComponent,
		ShippingTimeLineComponent,
		PickupRequestTimeLineComponent,
		PickupRequestParcelsComponent,
		PickupRequestParcelsDetailsComponent,
		TopSellingProductsComponent,
		ProgressChartComponent,
		InverseTableBackgroundComponent,
		QrScannerComponent,
		BarcodeComponent,
		ScanModalComponent,
		HeaderSettingsComponent,
		HeaderAdministrationComponent,
		MathCalculatorComponent,
		NgbdSortableHeaderDirective,
		OnlyNumbersDirective,
		ImageResizeDirective,
		DecimalDirective,
		SearchPipe,
		DateFormatPipe,
		TruncatePipe,
		ShortNumberPipe,
		SanitizeHtmlPipe,
		TimeAgoPipe,
		CapitalizePipe,
		MonthTranslatePipe,
		TwoDecimalPipe,
		AppTitlePipe,
		NumberToWordsPipe,
		ApiSyncModalComponent,
		LoadingTableComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		NgbDropdownModule,
		DragulaModule.forRoot(),
		TranslateModule.forChild(),
		CarouselModule,
		SwiperModule,
		NgApexchartsModule,
		NgxSkeletonLoaderModule,
		NgbTooltipModule,
		NgOptimizedImage,
		QRCodeModule,
		NgSelectModule,
		ZXingScannerModule,
		BidiModule
	],
	providers: [NavService, LayoutService, DecimalPipe],
	exports: [
		NgbModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		LoaderComponent,
		BreadcrumbComponent,
		FeatherIconsComponent,
		TapToTopComponent,
		SvgIconComponent,
		SwiperModule,
		CardBtnComponent,
		CardBtnComponent,
		DeleteItemComponent,
		SuccessMessageComponent,
		EmployeeCodeAccessComponent,
		ConfirmItemComponent,
		TimeLineComponent,
		StatsNumbersComponent,
		OverallBalanceComponent,
		CardComponent,
		OrdersByCategoriesComponent,
		TopSellingProductsComponent,
		ShippingTimeLineComponent,
		TopSellingProductsComponent,
		ProgressChartComponent,
		InverseTableBackgroundComponent,
		QrScannerComponent,
		BarcodeComponent,
		ScanModalComponent,
		MathCalculatorComponent,
		NgbdSortableHeaderDirective,
		OnlyNumbersDirective,
		ImageResizeDirective,
		DecimalDirective,
		DecimalDirective,
		SearchPipe,
		DateFormatPipe,
		ShortNumberPipe,
		SanitizeHtmlPipe,
		TruncatePipe,
		CapitalizePipe,
		TwoDecimalPipe,
		MonthTranslatePipe,
		AppTitlePipe,
		NumberToWordsPipe,
		ApiSyncModalComponent,
		LoadingTableComponent
	]
})
export class SharedModule {}
